import { render } from "./Suporte.vue?vue&type=template&id=280569b7&scoped=true"
import script from "./Suporte.vue?vue&type=script&lang=js"
export * from "./Suporte.vue?vue&type=script&lang=js"

import "./Suporte.vue?vue&type=style&index=0&id=280569b7&scoped=true&lang=css"

import exportComponent from "E:\\amapa-lp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280569b7"]])

export default __exports__